// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Tooltip/Basic.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Button, Tooltip, Notifications, view, Action } from '@sail/ui';
export const Basic = () => {
  return <view.div css={{
    layout: 'row',
    alignY: 'center',
    gap: 'xxlarge'
  }}>
      <Tooltip type="description" trigger={<Button type="primary" disabled onPress={undefined}>
            Pay out to bank
          </Button>}>
        You have no available balance to pay out. You can create payouts when
        you've accumulated a positive balance again.
      </Tooltip>

      <Tooltip type="label" trigger={<Action onPress={undefined} css={{
      layout: 'inline-row'
    }}>
            <Notifications />
          </Action>}>
        Notifications
      </Tooltip>
    </view.div>;
};